import { OrderType, Payments } from "@/constants";
import { create } from "zustand";

export interface TradeFilters{
  amount?: string;
  paymentType?: Payments[];
  isSplit: OrderType[];
}
interface TradeFiltersStore {
  tradeFilters: TradeFilters;
  setTradeFilters: (tradeFilters: TradeFilters) => void;
}

export const useTradeStore = create<TradeFiltersStore>((set) => ({
  tradeFilters: {
    amount: "",
    paymentType: [],
    isSplit: [],
  },
  setTradeFilters: (values) => {
    return set((state) => {
      const _tradeFilters = Object.assign({}, state.tradeFilters, values);
      return {
        tradeFilters: _tradeFilters,
      };
    });
  },
}));
